import React, { useState } from 'react';
import { Box } from '@mui/material';
import DepositsTable from './DepositsTable';
import DepositDetail from './DepositDetail';
import AssignDepositWizard from './AssignDepositWizard';
import { getDeposits, getDepositsGlobal } from '../../api/paymentApi';

// Top-level container for the Deposits tab — owns the list ↔ detail drill-down switch
// and the "Add Deposit" wizard, mirroring how Payments.jsx hands TransactionTable a
// fetchFn + a showGlobalFilters flag rather than each component reaching for role state.
const DepositsTab = ({ showGlobalFilters = false, canManageDeposits = false }) => {
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [addingDeposit, setAddingDeposit] = useState(false);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchFn = showGlobalFilters ? getDepositsGlobal : getDeposits;

  if (selectedDeposit) {
    return (
      <DepositDetail
        deposit={selectedDeposit}
        showGlobalFilters={showGlobalFilters}
        canManageDeposits={canManageDeposits}
        onBack={() => setSelectedDeposit(null)}
      />
    );
  }

  if (addingDeposit && canManageDeposits) {
    return (
      <AssignDepositWizard
        onClose={() => setAddingDeposit(false)}
        onSaved={() => setRefreshToken((k) => k + 1)}
      />
    );
  }

  return (
    <Box>
      <DepositsTable
        key={refreshToken}
        fetchFn={fetchFn}
        showGlobalFilters={showGlobalFilters}
        canAddDeposit={canManageDeposits}
        onAddDeposit={() => setAddingDeposit(true)}
        onSelectDeposit={setSelectedDeposit}
      />
    </Box>
  );
};

export default DepositsTab;
